/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityHarvestDto } from '../../models/facility-harvest-dto';

export interface GetFullHarvest$Params {
  harvestId: number;
}

export function getFullHarvest(http: HttpClient, rootUrl: string, params: GetFullHarvest$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityHarvestDto>> {
  const rb = new RequestBuilder(rootUrl, getFullHarvest.PATH, 'get');
  if (params) {
    rb.path('harvestId', params.harvestId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FacilityHarvestDto>;
    })
  );
}

getFullHarvest.PATH = '/api/harvests/{harvestId}/full-harvest';
